import { isObject } from '@aviata/type-guards';
import { isPassengersData } from '@aviata/booking-data';
import type { Airflow } from '@aviata/platform-types';

import type { BookingState, NormalizedPassenger } from './types';

const defaultState: BookingState = {
  passengers: {}, // TODO: Add necessary data
  ticketPrice: '',
  packageInfo: null,
  products: {
    state: null,
    products: null,
  },
  contacts: null,
  ancillaries: {},
  seatMap: null,
  roaming: null,
  flow: 'classic',
};

const getPassengers = (passengers: unknown) => {
  return isPassengersData(passengers) ? passengers : {};
};

export const getDefaultState = (rawData: unknown): BookingState => {
  if (isObject(rawData)) {
    return {
      ...defaultState,
      passengers: getPassengers(rawData.passengers),
    };
  }

  return defaultState;
};

export function mapSavedPassenger(
  passenger: Airflow.Booking.Passenger,
): NormalizedPassenger {
  return {
    ...passenger,
    fullName: passenger.full_name,
    firstName: passenger.first_name,
    lastName: passenger.last_name,
  };
}
